module.exports = "/_next/static/images/8f153855cce940aa6e2b4409c2ae4dd5-card.png";